import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectOverviewStateService } from '../../../../../services/project-overview-state-service';
import { RequestService } from '../../../../../services/request.service';
import { Subject } from 'rxjs';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ProductTypeCriteriumService } from 'src/app/services/product-type-criterium-service';

@Component({
  selector: 'pending-container',
  templateUrl: './pending-container.component.html',
  styleUrls: ['./pending-container.component.scss']
})
export class PendingContainerComponent extends SubscriptionBasedComponent
  implements OnInit {
  @Output()
  reloadCountChange = new EventEmitter<any>();

  @Input()
  selectedOverview: string;

  @Input()
  parentSubject: Subject<any>;

  reloadData = new EventEmitter<any>();
  reloadCounts = new EventEmitter<any>();

  designCount = 0;
  printCount = 0;
  finishCount = 0;
  supplierCount = 0;
  placeCount = 0;
  verifyLocationCount = 0;

  constructor(
    private projectOverviewStateService: ProjectOverviewStateService,
    private requestService: RequestService,
    private productTypeCriteriumService: ProductTypeCriteriumService
  ) {
    super();
  }

  ngOnInit() {
    this.parentSubject.subscribe(event => {
      if (event === 'pending') {
        this.selectedOverview = this.projectOverviewStateService.getselectedPendingView();
        if (this.selectedOverview === '') {
          this.changeSelectedView('pending');
        }
      }
    });
    this.selectedOverview = this.projectOverviewStateService.getselectedPendingView();
    if (this.selectedOverview === '') {
      this.changeSelectedView('pending');
    }

    this.addSubscription(this.reloadCounts, () => {
      this.designCount = 0;
      this.printCount = 0;
      this.finishCount = 0;
      this.supplierCount = 0;
      this.placeCount = 0;
      this.verifyLocationCount = 0;
      this.addSubscription(
        this.requestService.get(
          '/subprojects/projectSubStatusCounts',
          this.productTypeCriteriumService.generateTypeCriteriumParam()
        ),
        counts => {
          this.designCount = counts.body.designCount;
          this.printCount = counts.body.printCount;
          this.finishCount = counts.body.finishCount;
          this.supplierCount = counts.body.supplierCount;
          this.placeCount = counts.body.placeCount;
          this.verifyLocationCount = counts.body.verifyLocationCount;
        }
      );
    });

    this.addSubscription(
      this.productTypeCriteriumService.getTypeCriteriumChangedSubscribable(),
      () => {
        this.reloadCounts.emit();
      }
    );

    this.reloadCounts.emit();
  }

  changeSelectedView(value: string) {
    this.projectOverviewStateService.setselectedPendingView(value);
    this.selectedOverview = this.projectOverviewStateService.getselectedPendingView();
  }

  refreshCounts() {
    this.reloadData.emit();
    this.reloadCounts.emit();
  }

  getSelectButtonWidth(label: string) {
    switch (label) {
      case 'Ontwerp':
        if (this.designCount == null || this.designCount === 0) {
          return { padding: 0 };
        }
        return {};
      case 'Print':
        if (this.printCount == null || this.printCount === 0) {
          return { padding: 0 };
        }
        return {};
      case 'Afwerking':
        if (this.finishCount == null || this.finishCount === 0) {
          return { padding: 0 };
        }
        return {};
      case 'Ext. leveranciers':
        if (this.supplierCount == null || this.supplierCount === 0) {
          return { padding: 0 };
        }
        return {};
      case 'Locatiebepaling':
        if (
          this.verifyLocationCount == null ||
          this.verifyLocationCount === 0
        ) {
          return { padding: 0 };
        }
        return {};
      case 'Te plaatsen':
        if (this.placeCount == null || this.placeCount === 0) {
          return { padding: 0 };
        }
        return {};
    }
  }
}
